import { PhoneIcon } from '@chakra-ui/icons'
import { Button, Flex, Icon, Spacer, Text } from '@chakra-ui/react'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectAppLanguage } from 'src/redux/app/selectors'
import { changeLanguage } from 'src/redux/app/slice'
import { AppLanguage } from 'src/redux/app/types'
import { ReactComponent as FetchLogo } from '../../assets/images/fetch-logo.svg'
import CartButton from '../CartDrawer/components/CartButton'
import { PHONE_NUMBER } from './constants'
import { getButtonColor, getButtonWeight } from './utils'

export const AppHeader: React.FC = () => {
  const dispatch = useDispatch()
  const language = useSelector(selectAppLanguage)

  const renderLanguageButton = (lang: AppLanguage, index: number) => (
    <Button
      onClick={() => dispatch(changeLanguage(lang))}
      variant='ghost'
      style={{
        backgroundColor: 'rgba(0,0,0,0)',
        padding: '0',
        fontWeight: getButtonWeight(language, lang),
        color: getButtonColor(language, lang),
        marginRight: index === 1 ? 5 : 0,
      }}
    >
      {lang}
    </Button>
  )

  const renderSeparator = () => (
    <span
      style={{
        height: '0.8rem',
        borderRight: '1px solid black',
      }}
    />
  )

  const renderPhoneDetails = () => (
    <Flex align='center' mr={5}>
      <Icon as={PhoneIcon} color='gray' />
      <Text ml={2} fontWeight='bold'>
        {PHONE_NUMBER}
      </Text>
    </Flex>
  )

  return (
    <Flex px='42px' py='12px' boxShadow='md' alignItems='center' top={0} zIndex={10} bg='white'>
      <FetchLogo width='100px' />
      <Spacer />
      {renderLanguageButton('fin', 0)}
      {renderSeparator()}
      {renderLanguageButton('en', 1)}
      {renderPhoneDetails()}
      <CartButton />
    </Flex>
  )
}

export default AppHeader
